export default __webpack_public_path__ + "static/media/publishTraining.aae7f487.png";